import React from 'react';
import { CustomerPortal } from '../types/customerPortal';

// import { toFriendlyName } from '../utils/strings'; TODO: can't import this because snippet server complains lodash is missing
const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);
const toFriendlyName = (str: string) => str.toLowerCase().replace('_', ' ').trim().split(' ').map(capitalize).join(' ');
const isTextarea = (option: string) => option.toLowerCase() === 'other';

type Props = Pick<CustomerPortal, 'id' | 'features'> & { subscriptionId: string };

export default function CancellationForm({ id, features, subscriptionId }: Props) {
    return (
        <form id={`cancelForm${id}`} action="#" method="POST" style={{ display: 'none' }}>
            <input type="hidden" name="subscriptionId" value={subscriptionId} />
            <div className="shadow overflow-hidden sm:rounded-md">
                <div className="px-4 py-5 bg-white space-y-6 sm:p-6">
                    <fieldset>
                        <div>
                            <legend className="text-base font-medium text-gray-900">We're sad to see you go.</legend>
                            <p className="text-sm text-gray-500">
                                We'd love to hear why you are thinking about cancelling.
                            </p>
                        </div>
                        {features.subscription_cancel.cancellation_reason.options
                            .sort((o1, o2) => (isTextarea(o1) ? 1 : isTextarea(o2) ? -1 : 0))
                            .map((option) => (
                                <CancelOption option={option} key={option} />
                            ))}
                        <div id={`cancelFormError${id}`} className="mt-4 text-red-500 text-sm text-right"></div>
                    </fieldset>
                </div>
                <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                    <button
                        id="modalCancel"
                        type="button"
                        className="mr-2 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md bg-white hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                        Back
                    </button>
                    <button
                        type="submit"
                        className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                        End Subscription
                    </button>
                </div>
            </div>
        </form>
    );
}

function CancelOption(props: { option: string }) {
    const { option } = props;
    const textArea = isTextarea(option);
    return (
        <div className="mt-4 space-y-4" key={option}>
            <div className="flex items-center">
                {textArea && <CancellationTextarea option={option} />}
                {!textArea && (
                    <>
                        <input
                            id={option}
                            name={option}
                            type="checkbox"
                            className="pricewell-cancel-reason focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                        />
                        <label htmlFor={option} className="ml-3 block text-sm font-medium text-gray-700">
                            {toFriendlyName(option)}
                        </label>
                    </>
                )}
            </div>
        </div>
    );
}

function CancellationTextarea(props: { option: string }) {
    return (
        <>
            <label className="block text-sm font-medium text-gray-700 flex flex-col w-full">
                <span>{toFriendlyName(props.option)}</span>
                <textarea
                    name={props.option}
                    rows={3}
                    autoComplete="off"
                    className="pricewell-cancel-reason shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border border-gray-300 rounded-md p-4"
                    placeholder="What could we have done better?"
                ></textarea>
            </label>
        </>
    );
}
